class LpFaqJunior {
  constructor(el) {
    this.el = el;
    this.items = Array.from(el.querySelectorAll('[data-faq-item]'));
    this.items.forEach(item => {
      const trigger = item.querySelector('.lp-faq-jr__trigger');
      if (trigger) trigger.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(item) {
    const isOpen = item.classList.contains('is-open');
    const trigger = item.querySelector('.lp-faq-jr__trigger');
    const answer = item.querySelector('.lp-faq-jr__answer');
    if (!trigger || !answer) return;

    if (isOpen) {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
    } else {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
    }
  }
}

document.querySelectorAll('[data-faq-accordion]').forEach(el => new LpFaqJunior(el));

document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-faq-accordion]').forEach(el => new LpFaqJunior(el));
});
